import * as React from "react"
const SvgTasks = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m5.525 16.604 3.55-3.55q.3-.3.7-.288a1.006 1.006 0 0 1 .975 1.013q0 .4-.275.7l-4.225 4.25q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.15-2.15a.95.95 0 0 1-.275-.7q0-.426.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275zm0-8 3.55-3.55q.3-.3.7-.288a1.006 1.006 0 0 1 .975 1.013q0 .4-.275.7l-4.225 4.25q-.3.3-.7.3a.96.96 0 0 1-.7-.3L2.7 8.579a.95.95 0 0 1-.275-.7q0-.426.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275zM14 17.429a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.286h7q.424 0 .712.287.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288h-7Zm0-8a.97.97 0 0 1-.713-.288A.97.97 0 0 1 13 8.43a.97.97 0 0 1 .287-.713A.97.97 0 0 1 14 7.43h7q.424 0 .712.287.288.288.288.713c0 .425-.096.52-.288.712A.97.97 0 0 1 21 9.43z" />
  </svg>
)
export default SvgTasks
